export class BucketSummaryModel {
    bucketClientId: string;
    totalLicenses: number;
    totalLicensesInUse: number;
    totalLicensesAvailable: number;
}
